import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Footer from "./Footer";
import Header from "./Header";
import MainContent from "./MainContent";
import CustomSnackbar from "../Common/CustomSnackbar";

function Layout() {
  const snackbarProp = useSelector((state) => state.snackbar);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // remove scrollbar when loading
    document.body.style.overflow = "hidden";

    setTimeout(() => {
      setIsLoading(false);
      document.body.style.overflow = "auto";
    }, 1500);
  }, []);

  return (
    <div>
      {isLoading && (
        <div className="loading-container">
          <span className="loading-dot"></span>
          <span className="loading-dot"></span>
          <span className="loading-dot"></span>
        </div>
      )}

      <Header />
      <MainContent />
      <Footer />
      {
        <CustomSnackbar
          open={snackbarProp.open}
          message={snackbarProp.message}
          severity={snackbarProp.severity}
          action={snackbarProp.action}
        />
      }
    </div>
  );
}

export default Layout;
